import { Component } from "@angular/core";

@Component({
  selector: "app-screen-users",
  templateUrl: "./users.component.html",
  styleUrls: ["./users.component.less"],
})
export class UsersComponent {
}
